import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomerPageLayout from "../customer-page-layout/CustomerPageLayout";
import Button from "../../../common/ekedc-components/button/Button";
import styles from "./transfer-unit-intro.module.scss";
import { RootState } from "../../../stores/store";
import { NotEligibleModal } from "./components/NotEligibleModal";
import { ApplicationRoutes } from "../../../routes";

const SignalTransferIllustration: React.FC = () => (
	<img
		src={`${process.env.PUBLIC_URL ?? ""}/gifs/signal-transfer.gif`}
		alt="Transfer units"
		width={150}
		height={150}
		className={styles.illustrationImg}
	/>
);

const ProfileIcon: React.FC = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
		<path d="M16.0001 13.9997C16.0001 14.3678 15.7003 14.6702 15.3345 14.6298C12.3339 14.2987 10 11.7551 10 8.66634C10 5.57761 12.3339 3.03399 15.3345 2.70285C15.7003 2.66246 16.0001 2.96482 16.0001 3.33301V13.9997Z" fill="var(--app-primary)" />
		<path d="M16.0001 27.3331C16.0001 27.7012 15.7016 27.9998 15.3335 27.9998H9.53367C6.77224 27.9998 4.44339 25.6565 5.62937 23.1628C7.33269 19.5812 10.8871 16.9269 15.3333 16.6845C15.7009 16.6644 16.0001 16.9649 16.0001 17.3331V27.3331Z" fill="var(--app-primary)" />
		<path d="M18.6688 5.53281C19.3315 5.53281 19.8688 4.99555 19.8688 4.33281C19.8688 3.67007 19.3315 3.13281 18.6688 3.13281C18.006 3.13281 17.4688 3.67007 17.4688 4.33281C17.4688 4.99555 18.006 5.53281 18.6688 5.53281Z" fill="var(--app-primary)" />
		<path d="M18.6688 9.8668C19.3315 9.8668 19.8688 9.32954 19.8688 8.6668C19.8688 8.00406 19.3315 7.4668 18.6688 7.4668C18.006 7.4668 17.4688 8.00406 17.4688 8.6668C17.4688 9.32954 18.006 9.8668 18.6688 9.8668Z" fill="var(--app-primary)" />
		<path d="M22.666 7.66602C23.2183 7.66602 23.666 7.2183 23.666 6.66602C23.666 6.11373 23.2183 5.66602 22.666 5.66602C22.1137 5.66602 21.666 6.11373 21.666 6.66602C21.666 7.2183 22.1137 7.66602 22.666 7.66602Z" fill="var(--app-primary)" />
		<path d="M22.666 11.666C23.2183 11.666 23.666 11.2183 23.666 10.666C23.666 10.1137 23.2183 9.66602 22.666 9.66602C22.1137 9.66602 21.666 10.1137 21.666 10.666C21.666 11.2183 22.1137 11.666 22.666 11.666Z" fill="var(--app-primary)" />
		<path d="M18.6688 14.1988C19.3315 14.1988 19.8688 13.6616 19.8688 12.9988C19.8688 12.3361 19.3315 11.7988 18.6688 11.7988C18.006 11.7988 17.4688 12.3361 17.4688 12.9988C17.4688 13.6616 18.006 14.1988 18.6688 14.1988Z" fill="var(--app-primary)" />
		<path d="M18.6688 18.5328C19.3315 18.5328 19.8688 17.9956 19.8688 17.3328C19.8688 16.6701 19.3315 16.1328 18.6688 16.1328C18.006 16.1328 17.4688 16.6701 17.4688 17.3328C17.4688 17.9956 18.006 18.5328 18.6688 18.5328Z" fill="var(--app-primary)" />
		<path d="M22.666 18.334C23.2183 18.334 23.666 17.8863 23.666 17.334C23.666 16.7817 23.2183 16.334 22.666 16.334C22.1137 16.334 21.666 16.7817 21.666 17.334C21.666 17.8863 22.1137 18.334 22.666 18.334Z" fill="var(--app-primary)" />
		<path d="M26.666 23C27.2183 23 27.666 22.5523 27.666 22C27.666 21.4477 27.2183 21 26.666 21C26.1137 21 25.666 21.4477 25.666 22C25.666 22.5523 26.1137 23 26.666 23Z" fill="var(--app-primary)" />
		<path d="M18.6688 23.1988C19.3315 23.1988 19.8688 22.6616 19.8688 21.9988C19.8688 21.3361 19.3315 20.7988 18.6688 20.7988C18.006 20.7988 17.4688 21.3361 17.4688 21.9988C17.4688 22.6616 18.006 23.1988 18.6688 23.1988Z" fill="var(--app-primary)" />
		<path d="M22.6687 23.1988C23.3315 23.1988 23.8687 22.6616 23.8687 21.9988C23.8687 21.3361 23.3315 20.7988 22.6687 20.7988C22.006 20.7988 21.4688 21.3361 21.4688 21.9988C21.4688 22.6616 22.006 23.1988 22.6687 23.1988Z" fill="var(--app-primary)" />
		<path d="M18.6688 27.8668C19.3315 27.8668 19.8688 27.3295 19.8688 26.6668C19.8688 26.0041 19.3315 25.4668 18.6688 25.4668C18.006 25.4668 17.4688 26.0041 17.4688 26.6668C17.4688 27.3295 18.006 27.8668 18.6688 27.8668Z" fill="var(--app-primary)" />
		<path d="M22.6687 27.8668C23.3315 27.8668 23.8687 27.3295 23.8687 26.6668C23.8687 26.0041 23.3315 25.4668 22.6687 25.4668C22.006 25.4668 21.4688 26.0041 21.4688 26.6668C21.4688 27.3295 22.006 27.8668 22.6687 27.8668Z" fill="var(--app-primary)" />
		<path d="M26.666 27.666C27.2183 27.666 27.666 27.2183 27.666 26.666C27.666 26.1137 27.2183 25.666 26.666 25.666C26.1137 25.666 25.666 26.1137 25.666 26.666C25.666 27.2183 26.1137 27.666 26.666 27.666Z" fill="var(--app-primary)" />
	</svg>
);

const VerifiedBadgeIcon: React.FC = () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.4632 3.78869C14.4159 1.83606 17.5816 1.83606 19.5343 3.78869L19.8343 4.08868C20.3969 4.65129 21.1599 4.96736 21.9556 4.96736H22.032C24.7935 4.96736 27.032 7.20594 27.032 9.96736V10.0438C27.032 10.8395 27.3481 11.6026 27.9108 12.1652L28.2108 12.4652C30.1633 14.4177 30.1633 17.5836 28.2108 19.5362L27.9108 19.8363C27.3481 20.3988 27.032 21.1618 27.032 21.9576V22.034C27.032 24.7954 24.7935 27.034 22.032 27.034H21.9556C21.1599 27.034 20.3969 27.3501 19.8343 27.9126L19.5343 28.2127C17.5816 30.1653 14.4159 30.1653 12.4632 28.2127L12.1632 27.9126C11.6006 27.3501 10.8375 27.034 10.0419 27.034H9.9654C7.20399 27.034 4.96542 24.7954 4.96542 22.034V21.9576C4.96542 21.1618 4.64934 20.3988 4.08674 19.8363L3.78674 19.5362C1.83411 17.5836 1.83411 14.4177 3.78674 12.4652L4.08674 12.1652C4.64934 11.6026 4.96542 10.8395 4.96542 10.0438V9.96736C4.96542 7.20593 7.20399 4.96736 9.96542 4.96736H10.0419C10.8375 4.96736 11.6006 4.65129 12.1632 4.08868L12.4632 3.78869ZM20.5799 13.1582C20.8951 12.7047 20.7831 12.0816 20.3296 11.7663C19.8761 11.451 19.253 11.5631 18.9377 12.0165L14.3684 18.5888L12.2331 16.7077C11.8187 16.3426 11.1868 16.3825 10.8218 16.797C10.4567 17.2114 10.4967 17.8433 10.9111 18.2084L13.888 20.831C14.102 21.0196 14.3863 21.1077 14.6693 21.0734C14.9524 21.0392 15.2073 20.8857 15.3701 20.6516L20.5799 13.1582Z"
			fill="var(--app-primary)"
		/>
	</svg>
);

export const TransferUnitIntroPage: React.FC = () => {
	const navigate = useNavigate();
	const energyProfile = useSelector((state: RootState) => state?.customerEnergyProfile);

	const meterNumber = energyProfile?.meterNumber ?? "—";
	// TODO: replace with /api/vending/transfer-units balance when the endpoint is wired.
	// Temporary positive value so the eligible flow can be exercised end-to-end.
	const availableUnits = 150;
	const [showNotEligible, setShowNotEligible] = useState(false);

	const handleStart = () => {
		if (availableUnits <= 0) {
			setShowNotEligible(true);
			return;
		}
		navigate(`/${ApplicationRoutes.TRANSFER_UNIT_VERIFY}`);
	};

	return (
		<CustomerPageLayout
			title={undefined}
			onBack={() => navigate(-1)}
			containerClass={styles.layoutContainer}
			contentContainerClass={styles.layoutContent}
		>
			<form
				className={styles.page}
				onSubmit={e => {
					e.preventDefault();
					handleStart();
				}}
			>
				{/* <header className={styles.headerRow}>
					<button type="button" className={styles.backButton} onClick={() => navigate(-1)} aria-label="Go back">
						<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
							<path
								d="M14.6667 5.5L9.16667 11L14.6667 16.5"
								stroke="var(--app-primary-text)"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
				</header> */}

				<div className={styles.scrollContent}>
					<div className={styles.illustration}>
						<SignalTransferIllustration />
					</div>

					<div className={styles.intro}>
						<h1 className={styles.title}>Unit Transfer</h1>
						<p className={styles.subtitle}>
							Share electricity with friends and family by sending units directly from your meter in seconds.
						</p>
					</div>

					<section className={styles.infoCard}>
						<div className={styles.infoRow}>
							<ProfileIcon />
							<div className={styles.infoMain}>
								<span className={styles.infoTitle}>Energy Profile</span>
								<span className={styles.infoText}>
									We will automatically use your saved meter for this transfer.
								</span>
							</div>
						</div>
						<div className={styles.infoRow}>
							<VerifiedBadgeIcon />
							<div className={styles.infoMain}>
								<span className={styles.infoTitle}>Ownership Verification</span>
								<span className={styles.infoText}>
									Keep your last 3 token amount ready to confirm your identity.
								</span>
							</div>
						</div>
					</section>

					<section className={styles.statsCard}>
						<div className={styles.statsCol}>
							<span className={styles.statsLabel}>Available Balance</span>
							<span className={styles.statsValue}>{availableUnits.toLocaleString()} Units</span>
						</div>
						<div className={styles.statsDivider} />
						<div className={styles.statsCol}>
							<span className={styles.statsLabel}>Meter</span>
							<span className={styles.statsMeter}>{meterNumber}</span>
						</div>
					</section>
				</div>

				<footer className={styles.footer}>
					<Button type="submit" text="Start Transfer" />
				</footer>
			</form>

			{showNotEligible && <NotEligibleModal onClose={() => setShowNotEligible(false)} />}
		</CustomerPageLayout>
	);
};

export default TransferUnitIntroPage;
